var scope_0 = require('/Users/shinyaueda/git/nipo_web_gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/35c9da1a291b9b93f33204ba5d7ef02a.js').default;
var scope_1 = require('/Users/shinyaueda/git/nipo_web_gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5153474a006a9a399d63b57f4064da31.js').default;
var scope_2 = require('/Users/shinyaueda/git/nipo_web_gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c528e1d5dccbf3f3ac04e7375f37680d.js').default;
var scope_3 = require('/Users/shinyaueda/git/nipo_web_gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    